import dayjs from 'dayjs';
import {scaleFromCenter} from 'ol/extent';
import GeoJSON from 'ol/format/GeoJSON';
import OLVectorTileLayer from 'ol/layer/VectorTile';

const format = new GeoJSON();
export function getExtentForGeometry(geometry) {
  return format.readGeometry(geometry).getExtent();
}

export const formatCoords = (coordinate, opt_precision = 5) => {
  if (coordinate) {
    return `${Math.abs(coordinate[1].toFixed(opt_precision))}\u00b0${
      coordinate[1] < 0 ? 'S' : 'N'
    },  ${Math.abs(coordinate[0].toFixed(opt_precision))}\u00b0${
      coordinate[0] < 0 ? 'W' : 'E'
    }`;
  } else {
    return '';
  }
};

export const getFeatureFromEvent = event => {
  const features = event.map.getFeaturesAtPixel(event.pixel, {
    layerFilter: layer => layer instanceof OLVectorTileLayer,
  });
  return features && features[0];
};

export const getCenterForGeometry = geometry => {
  const extent = getExtentForGeometry(geometry);
  return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
};

export const getVisualizationSeries = feed => {
  const source = feed.source[0];
  return source.config.visualization_series_id || source.config.series_id;
};

export function getMosaicsByDate(mosaicsInfo, observedDate) {
  return mosaicsInfo
    .filter(mosaic => dayjs(mosaic.first_acquired).isSame(dayjs(observedDate)))
    .sort((a, b) => {
      return a.last_acquired > b.last_acquired ? -1 : 1;
    });
}

/**
 * Scale an extent in geographic coordinates and limit it to within
 * the world bounds. This modifies the input extent in place.
 * @param {Array<number>} extent The extent in geographic coordinates.
 * @param {number} The scale factor.
 */
export function scaleExtent(extent, factor) {
  scaleFromCenter(extent, factor);
  if (extent[0] < -180) {
    extent[0] = -180;
  }
  if (extent[1] < -85) {
    extent[1] = -85; // allowing for transform to web mercator
  }
  if (extent[2] > 180) {
    extent[2] = 180;
  }
  if (extent[3] > 85) {
    extent[3] = 85; // allowing for transform to web mercator
  }
}
